"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _ykbUtils = require("ykb-utils");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledTextarea = require("./StyledTextarea");
var _lineCounter = _interopRequireDefault(require("./lineCounter"));
var _excluded = ["rows", "cols", "value", "defaultValue", "disabled", "readOnly", "placeholder", "validationItem", "className", "counter", "counterLimit", "counterType", "counterValue", "validation", "inputRef", "showLineNumber"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Textarea = /*#__PURE__*/function (_React$Component) {
  function Textarea() {
    var _this;
    (0, _classCallCheck2.default)(this, Textarea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Textarea, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      focused: false,
      scrollTop: 0
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (e) {
      if (_this.props.onChange) _this.props.onChange(e);
    });
    (0, _defineProperty2.default)(_this, "onInput", function (e) {
      if (_this.props.upperCase) {
        e.target.value = e.target.value.toLocaleUpperCase();
      }
    });
    return _this;
  }
  (0, _inherits2.default)(Textarea, _React$Component);
  return (0, _createClass2.default)(Textarea, [{
    key: "checkWarning",
    value: function checkWarning() {
      var _this$props = this.props,
        value = _this$props.value,
        counterValue = _this$props.counterValue,
        counterLimit = _this$props.counterLimit;
      if ((0, _ykbUtils.isNullOrUndefined)(counterValue) && !(0, _ykbUtils.isNullOrUndefined)(value)) {
        return value.length > counterLimit;
      }
      if (!(0, _ykbUtils.isNullOrUndefined)(counterValue)) {
        return counterValue > counterLimit;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        rows = _this$props2.rows,
        cols = _this$props2.cols,
        value = _this$props2.value,
        defaultValue = _this$props2.defaultValue,
        disabled = _this$props2.disabled,
        readOnly = _this$props2.readOnly,
        placeholder = _this$props2.placeholder,
        validationItem = _this$props2.validationItem,
        className = _this$props2.className,
        counter = _this$props2.counter,
        counterLimit = _this$props2.counterLimit,
        counterType = _this$props2.counterType,
        counterValue = _this$props2.counterValue,
        validation = _this$props2.validation,
        inputRef = _this$props2.inputRef,
        showLineNumber = _this$props2.showLineNumber,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      var cls = (0, _classnames.default)(className, {
        disabled: disabled === true,
        focused: this.state.focused,
        readonly: readOnly
      });
      var _counterValue = !(0, _ykbUtils.isNullOrUndefined)(counterValue) && counterValue || !(0, _ykbUtils.isNullOrUndefined)(value) && value.length || 0;
      var __counterValue = counterType == 'asc' ? _counterValue : counterLimit - _counterValue;
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        var _textarea = /*#__PURE__*/_react.default.createElement(_StyledTextarea.StyledTextarea, (0, _extends2.default)({
          className: cls,
          rows: rows,
          cols: cols,
          value: value,
          defaultValue: defaultValue,
          onChange: _this2.handleChange,
          onInput: _this2.onInput,
          disabled: disabled || false,
          readOnly: readOnly,
          placeholder: placeholder
        }, rest, {
          ref: function ref(i) {
            _this2.inputRef = i;
            if (inputRef) {
              inputRef(i);
            }
          },
          theme: theme,
          onScroll: function onScroll(event) {
            var scrollTop = event.target.scrollTop;
            _this2.setState({
              scrollTop: scrollTop
            });
          }
        }));
        if (counter) {
          return /*#__PURE__*/_react.default.createElement(_StyledTextarea.StyledTextareaContainer
          // $warning={value && value.length > counterLimit}
          , {
            $warning: _this2.checkWarning(),
            style: rest.style,
            theme: theme
          }, /*#__PURE__*/_react.default.createElement(_StyledTextarea.CounterWrapper, {
            $showLineNumber: showLineNumber
          }, /*#__PURE__*/_react.default.createElement(_lineCounter.default, {
            inputRef: _this2.inputRef,
            defaultValue: defaultValue,
            value: value,
            scrollTop: _this2.state.scrollTop,
            showLineNumber: showLineNumber
          }), _textarea), /*#__PURE__*/_react.default.createElement("span", null, __counterValue, " / ", counterLimit));
        } else {
          return /*#__PURE__*/_react.default.createElement(_StyledTextarea.CounterWrapper, {
            $showLineNumber: showLineNumber
          }, showLineNumber && /*#__PURE__*/_react.default.createElement(_lineCounter.default, {
            inputRef: _this2.inputRef,
            defaultValue: defaultValue,
            value: value,
            scrollTop: _this2.state.scrollTop,
            showLineNumber: showLineNumber
          }), _textarea);
        }
      });
    }
  }]);
}(_react.default.Component);
Textarea.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  readOnly: _propTypes.default.bool,
  rows: _propTypes.default.number,
  cols: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  validationItem: _propTypes.default.bool,
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  counter: _propTypes.default.bool,
  counterLimit: _propTypes.default.number,
  counterType: 'asc' | 'desc',
  showLineNumber: _propTypes.default.bool
};
Textarea.defaultProps = {
  readOnly: false,
  validationItem: true,
  disabled: false,
  rows: 6,
  cols: 50,
  counter: false,
  counterLimit: 4000,
  counterType: 'asc',
  showLineNumber: false
};
Textarea.displayName = 'Textarea';
var _default = exports.default = (0, _inputHOC.default)(Textarea);